import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { useEffect, useRef, useCallback, useState } from "react"
import { connect } from "react-redux"

import api from "apis"
import { useIntersection } from "helpers/use-intersection"

export default function withRecentlyViewed(WrappedComponent) {
  const InternalComponent = (props) => {
    const { styleCode } = props
    const ref = useRef()
    const inViewport = useIntersection(ref, "50px")
    const [recentlyViewed, setRecentlyViewed] = useState([])
    const cancelled = useRef(false)

    const fetchAndSet = useCallback(async () => {
      if (!cancelled.current && styleCode) {
        try {
          const result = await api.get(
            `/api/v10/products/${styleCode}/recently_viewed`
          )

          if (result?.data) {
            setRecentlyViewed(result.data)
          } else {
            throw new Error("Error on fetch recently_viewed")
          }
        } catch (error) {
          console.log(error)
        }
      }
    }, [styleCode])

    useEffect(() => {
      if (inViewport) {
        fetchAndSet()
      }
    }, [fetchAndSet, inViewport])

    useEffect(() => {
      return () => (cancelled.current = true)
    }, [])

    return (
      <Box ref={ref}>
        <WrappedComponent {...props} recentlyViewed={recentlyViewed} />
      </Box>
    )
  }

  InternalComponent.propTypes = {
    styleCode: PropTypes.string,
  }

  const mapStateToProps = (state) => {
    return {
      styleCode: state.choices.style_code && state.choices.style_code.value,
    }
  }

  const mapDispatchToProps = () => ({})

  const Component = connect(
    mapStateToProps,
    mapDispatchToProps
  )(InternalComponent)

  return Component
}
